import * as _ from "lodash"
import * as AsyncLock from "async-lock"
import { PASearch } from "../PA.Core/PASearch"

interface IDataMartCacheEntry {
    wbDataMartId: number
    wbCustIds: number[]
    wbProdIds: number[]
}

const vUI_Portfolio_Event_Search_schema = PASearch.createSimpleSchema([], ['WB_DATAMART_ID','WB_CUST_ID_PLANNING','WB_PROD_ID','WB_TAG_ID'])

export class DataMartUtils {
    private static lock = new AsyncLock()

    private static dctDM: {[wbDataMartId: number]: IDataMartCacheEntry} = {}

    static async getProducts(wbDataMartId: number): Promise<number[]> {
        if(wbDataMartId in DataMartUtils.dctDM)
            return DataMartUtils.dctDM[wbDataMartId]?.wbProdIds || []

        let ce = await DataMartUtils.loadCache(wbDataMartId)
        return ce?.wbProdIds || []
    }

    static async getCustomers(wbDataMartId: number): Promise<number[]> {
        if(wbDataMartId in DataMartUtils.dctDM)
            return DataMartUtils.dctDM[wbDataMartId]?.wbCustIds || []

        let ce = await DataMartUtils.loadCache(wbDataMartId)
        return ce?.wbCustIds || []

    }

    private static async loadCache(wbDataMartId: number): Promise<IDataMartCacheEntry> {
        return DataMartUtils.lock.acquire<IDataMartCacheEntry>("DM-" + wbDataMartId, async (done) => {
            try {
                let custResults = await PASearch.find('vUI_Portfolio_Event_Search', { where: { WB_DATAMART_ID: wbDataMartId } }, vUI_Portfolio_Event_Search_schema, [], 0, ['WB_CUST_ID_PLANNING'])
                let wbCustIds: number[] = _.filter(_.map(custResults, row => +row.WB_CUST_ID_PLANNING), id => id > 0)
                let prdResults = await PASearch.find('vUI_Portfolio_Event_Search', { where: { WB_DATAMART_ID: wbDataMartId } }, vUI_Portfolio_Event_Search_schema, [], 0, ['WB_PROD_ID'])
                let wbPrdIds: number[] = _.filter(_.map(prdResults, row => +row.WB_PROD_ID), id => id > 0)

                DataMartUtils.dctDM[wbDataMartId] = {
                    wbDataMartId: wbDataMartId,
                    wbCustIds: wbCustIds,
                    wbProdIds: wbPrdIds
                }
                done(undefined, DataMartUtils.dctDM[wbDataMartId])

            } catch(err) {
                done(err)
            }

        })
    }

}